// Сначала импортируем нужные штуки
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';

// Испорльзуем класс, так как могут появиться состояния и кэш.

// Создаем сервис для работы с файлами
export default class LocalFileEngine {
	// Хелпер для конвертации blob в base64
	private blobToBase64(blob: Blob): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => {
				const base64 = reader.result as string;
				// Убираем prefix "data:image/jpeg;base64,"
				resolve(base64.split(',')[1]);
			};
			reader.onerror = reject;
			reader.readAsDataURL(blob);
		});
	}

	private getMimeType(path: string): string {
		const ext = path.split('.').pop()?.toLowerCase();
		const mimeTypes: { [key: string]: string } = {
			jpg: 'image/jpeg',
			jpeg: 'image/jpeg',
			png: 'image/png',
			webp: 'image/webp',
			gif: 'image/gif',
			// добавь другие типы если нужно
		};
		return mimeTypes[ext || ''] || 'application/octet-stream';
	}

	async ensureDirectoryExists(path: string) {
		// Разбиваем путь на части
		const parts = path.split('/').filter((part) => part.length > 0);
		let currentPath = '';

		// Создаем каждую директорию по пути
		// slice(0, -1) исключает имя файла
		for (const part of parts.slice(0, -1)) {
			currentPath += `/${part}`;

			try {
				// Сначала проверяем существование
				await Filesystem.stat({
					path: currentPath,
					directory: Directory.Data, // Directory.Documents,
				});
			} catch (error) {
				// Если директории нет - создаем
				try {
					await Filesystem.mkdir({
						path: currentPath,
						directory: Directory.Data, // Directory.Documents,
						recursive: true,
					});
				} catch (mkdirError: any) {
					if (!mkdirError?.message?.includes('exists')) {
						throw mkdirError;
					}
				}
			}
		}
	}

	// Метод для скачивания и сохранения файла
	async downloadAndSaveFile(url: string, filePath: string) {
		try {
			// Скачиваем файл
			const response = await fetch(url);
			const blob = await response.blob();

			// Конвертируем blob в base64
			const base64Data = await this.blobToBase64(blob);

			// Сначала создаем все нужные директории
			await this.ensureDirectoryExists(filePath);

			// Сохраняем файл
			const savedFile = await Filesystem.writeFile({
				path: filePath,
				data: base64Data,
				directory: Directory.Data, // Directory.Documents или Directory.Data
			});

			console.log('savedFile', savedFile);

			// Получаем URI файла для отображения
			await Filesystem.getUri({
				path: filePath,
				directory: Directory.Data, // Directory.Documents,
			});

			return filePath;
		} catch (error) {
			console.error('Ошибка при сохранении файла:', error);
			throw error;
		}
	}

	async saveBase64ToFile(base64Data: string, filePath: string) {
		try {
			// Сначала создаем все нужные директории
			await this.ensureDirectoryExists(filePath);

			// Проверяем, не содержит ли base64 префикс (data:image/jpeg;base64,)
			const base64Clean = base64Data.includes('base64,') ? base64Data.split('base64,')[1] : base64Data;

			// Сохраняем файл
			const savedFile = await Filesystem.writeFile({
				path: filePath,
				data: base64Clean,
				directory: Directory.Data, // Directory.Documents,
			});

			console.log('savedFile', savedFile);

			// Получаем URI файла для отображения
			await Filesystem.getUri({
				path: filePath,
				directory: Directory.Data, // Directory.Documents,
			});

			return filePath;
		} catch (error) {
			console.error('Ошибка при сохранении файла:', error);
			throw error;
		}
	}

	// Метод для чтения файла
	async readFile(path: string) {
		try {
			// Убираем префикс из пути
			// const relativePath = path.replace(/^file:\/\/\/storage\/emulated\/0\/Documents\//, '');

			const result = await Filesystem.readFile({
				path: path,
				directory: Directory.Data, // Directory.Documents,
			});

			// Определяем MIME-тип на основе расширения файла
			const mimeType = this.getMimeType(path);

			// Формируем полную data URL
			const data = `data:${mimeType};base64,${result.data}`;
			return data;
		} catch (error) {
			console.error('Ошибка чтения файла:', error);
			throw error;
		}
	}

	// Проверяем на android мы или нет
	checkPlatform() {
		return Capacitor.isNativePlatform();
	}
}
